import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const taxonomiesManifest: FeatureManifest = {
  id: 'catalog-taxonomies',
  path: 'catalogs/taxonomies',
  navPath: '/catalogs/taxonomies',
  label: 'Phân loại',
  requiredPermissions: ['catalogs'],
  navigationGroup: { id: 'catalogs', label: 'Quản lý danh mục' },
  load: () => import('./entry'),
}
